if (!customElements.get('variant-card-thumbnails')) {
  class VariantCardThumbnails extends HTMLElement {
    constructor() {
      super();

      this.card = this.closest('.card-wrapper');
      this.buttons = Array.from(
        this.querySelectorAll('.card-variant-thumbnail')
      );

      if (!this.card || this.buttons.length === 0) return;

      this.productLinks = Array.from(
        this.card.querySelectorAll('a[href*="/products/"]')
      );

      this.buttons.forEach((button) => {
        /*
         * Desktop:
         * Hovering previews the variant.
         *
         * Touch devices:
         * Tapping selects the variant and updates the main card link.
         */
        button.addEventListener('mouseenter', () => {
          this.selectVariant(button);
        });

        button.addEventListener('focus', () => {
          this.selectVariant(button);
        });

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.selectVariant(button);
        });
      });
    }

    getCardImage() {
      const images = Array.from(
        this.card.querySelectorAll('.card__media img')
      );

      /*
       * Spotlight can have a second hover image.
       * Prefer the first visible product-card image.
       */
      return images.find((image) => image.offsetParent !== null) || images[0];
    }

    selectVariant(button) {
      if (!button) return;

      const image = this.getCardImage();
      const imageSrc = button.dataset.imageSrc;
      const imageSrcset = button.dataset.imageSrcset;
      const variantUrl = button.dataset.variantUrl;

      this.buttons.forEach((item) => {
        const isActive = item === button;

        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (image && imageSrc) {
        image.src = imageSrc;

        if (imageSrcset) {
          image.srcset = imageSrcset.trim();
        }
      }

      if (variantUrl) {
        this.productLinks.forEach((link) => {
          link.href = variantUrl;
        });
      }
    }
  }

  customElements.define(
    'variant-card-thumbnails',
    VariantCardThumbnails
  );
}